import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';

i18n
  // Load translations from backend
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18n
  .init({
    // Default language - explicitly set to German
    fallbackLng: 'de',
    // List of supported languages - only include these
    supportedLngs: ['en', 'de'],
    // Force German to be loaded instead of language detection
    lng: 'de',
    // Debug in development
    debug: process.env.NODE_ENV === 'development',
    // Detect language from user's IP address (among other methods)
    detection: {
      order: ['localStorage', 'cookie', 'navigator', 'htmlTag', 'path', 'subdomain'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage', 'cookie'],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    // Load namespaces
    ns: ['common', 'home', 'chat'],
    defaultNS: 'common',
    // Backend configuration for loading translation files
    backend: {
      // Path to load translations from
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      // Allow partial loading
      allowMultiLoading: false
    },
  });

export default i18n; 